export default __webpack_public_path__ + "static/media/555.fc06fdcf.gif";